import * as yup from "yup"

const receiptGradeSchema = yup.object().shape({
  grade: yup.object().nullable().required("Grade is required"),
  rate: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .required("Rate is required"),
  quantity: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .required("Quantity is required"),
})

const receiptExpenseSchema = yup
  .object()
  .shape({
    expense_parameter: yup.object().nullable().optional(),
    kind: yup.object().nullable().optional(),
  })
  .test(
    "expense-param-kind-required",
    "Expense type is required when expense parameter is selected",
    function (value) {
      const hasParam =
        value?.expense_parameter != null && value.expense_parameter !== ""
      const hasKind = value?.kind != null && value.kind !== ""
      if (hasParam && !hasKind) {
        return this.createError({
          message:
            "Expense type is required when expense parameter is selected",
        })
      }
      if (hasKind && !hasParam) {
        return this.createError({
          message:
            "Expense parameter is required when expense type is selected",
        })
      }
      return true
    }
  )

export const receiptValidationSchema = yup.object().shape({
  seller: yup.object().nullable().required("Supplier is required"),
  officer: yup.object().nullable().required("Senior Officer is required"),
  junior_officer: yup
    .object()
    .nullable()
    .required("Junior Officer is required"),
  start_date: yup.date().required("Start date is required"),

  trades: yup
    .array()
    .of(
      yup.object().shape({
        buyer: yup.object().nullable().required("Buyer is required"),
        commodity_items: yup
          .array()
          .of(
            yup.object().shape({
              commodity: yup
                .object()
                .nullable()
                .required("Commodity is required"),
              commodity_variety: yup
                .object()
                .nullable()
                .required("Variety is required"),
              quantity_unit: yup
                .object()
                .nullable()
                .required("Quantity unit is required"),
              grades: yup
                .array()
                .of(receiptGradeSchema)
                .min(1, "At least one grade is required"),
            })
          )
          .min(1, "At least one commodity is required"),
      })
    )
    .min(1, "At least one buyer is required"),

  expenses: yup.array().of(receiptExpenseSchema).optional(),
})
